document.addEventListener('DOMContentLoaded', function () {
  const swiperWrappers = document.querySelectorAll('.product-media-swiper-wrapper');
  if (swiperWrappers.length === 0) return;

  const initSwiper = (wrapper) => {
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper is not defined yet.');
      return;
    }

    if (wrapper.mainSwiperInstance) {
      wrapper.mainSwiperInstance.destroy(true, true);
    }
    if (wrapper.thumbSwiperInstance) {
      wrapper.thumbSwiperInstance.destroy(true, true);
    }
    
    // Small timeout ensures styles are cleaned up if re-initializing
    const thumbSwiperEl = wrapper.querySelector('.product-media-swiper-thumbnails');
    const mainSwiperEl = wrapper.querySelector('.product-media-swiper-main');
    let isLoop = false;
    if (thumbSwiperEl) {
      const thumbWrapper = thumbSwiperEl.querySelector('.swiper-wrapper');
      // Calculate if the thumbnails actually overflow the container
      if (window.innerWidth >= 990) {
        isLoop = thumbWrapper.scrollHeight > thumbSwiperEl.clientHeight + 5;
      } else {
        isLoop = thumbWrapper.scrollWidth > thumbSwiperEl.clientWidth + 5;
      }
    } else {
      isLoop = mainSwiperEl.querySelectorAll('.swiper-slide').length > 1;
    }
    const mainLoop = mainSwiperEl.querySelectorAll('.swiper-slide').length > 1;

    if (!mainSwiperEl) return;

    let thumbSwiper = null;

    if (thumbSwiperEl) {
      thumbSwiper = new Swiper(thumbSwiperEl, {
        loop: isLoop,
        spaceBetween: 10,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        centerInsufficientSlides: true,
        watchOverflow: true,
        direction: 'horizontal',
        breakpoints: {
          990: {
            direction: 'vertical',
          }
        },
        keyboard: {
          enabled: true,
        },
        a11y: {
          enabled: true,
          slideRole: 'button',
        },
        mousewheel: {
          forceToAxis: true,
          sensitivity: 0.4,
          releaseOnEdges: true,
        },
      });

      if (isLoop) {
        thumbSwiperEl.addEventListener('wheel', (e) => {
          e.preventDefault();
        }, { passive: false });
      }
    }

    const nextEl = mainSwiperEl.querySelector('.swiper-button-next');
    const prevEl = mainSwiperEl.querySelector('.swiper-button-prev');

    const mainSwiper = new Swiper(mainSwiperEl, {
      loop: mainLoop,
      spaceBetween: 10,
      keyboard: {
        enabled: true,
      },
      a11y: {
        enabled: true,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      thumbs: {
        swiper: thumbSwiper
      },
      on: {
        slideChange: function (swiper) {
          if (thumbSwiper) {
            if (!isLoop) {
              thumbSwiper.slideTo(swiper.realIndex);
              thumbSwiper.slides.forEach(slide => {
                slide.classList.remove('swiper-slide-thumb-active');
                slide.removeAttribute('aria-current');
              });
              const activeThumb = thumbSwiper.slides[swiper.realIndex];
              if (activeThumb) {
                activeThumb.classList.add('swiper-slide-thumb-active');
                activeThumb.setAttribute('aria-current', 'true');
              }
            } else {
              thumbSwiper.slides.forEach(slide => slide.removeAttribute('aria-current'));
              const activeThumbs = thumbSwiper.el.querySelectorAll('.swiper-slide-thumb-active');
              activeThumbs.forEach(thumb => thumb.setAttribute('aria-current', 'true'));
            }
          }
        },
        init: function(swiper) {
          if (thumbSwiper) {
            if (!isLoop) {
              thumbSwiper.slides.forEach(slide => {
                slide.classList.remove('swiper-slide-thumb-active');
                slide.removeAttribute('aria-current');
              });
              const activeThumb = thumbSwiper.slides[swiper.realIndex];
              if (activeThumb) {
                activeThumb.classList.add('swiper-slide-thumb-active');
                activeThumb.setAttribute('aria-current', 'true');
              }
            } else {
              const activeThumbs = thumbSwiper.el.querySelectorAll('.swiper-slide-thumb-active');
              activeThumbs.forEach(thumb => thumb.setAttribute('aria-current', 'true'));
            }
          }
        }
      }
    });

    if (thumbSwiperEl && mainSwiper) {
      thumbSwiperEl.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          const slide = e.target.closest('.swiper-slide');
          if (slide) {
            e.preventDefault();
            const index = slide.getAttribute('data-swiper-slide-index');
            if (index !== null) {
              mainSwiper.slideToLoop(parseInt(index));
            } else {
              const slides = Array.from(thumbSwiper.slides);
              mainSwiper.slideTo(slides.indexOf(slide));
            }
          }
        }
      });
    }
    
    wrapper.mainSwiperInstance = mainSwiper;
    wrapper.thumbSwiperInstance = thumbSwiper;
    wrapper.classList.add('is-initialized');
  };

  const observer = new IntersectionObserver((entries, observerInstance) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Use requestAnimationFrame to ensure the DOM is fully painted before Swiper measures clientWidth
        requestAnimationFrame(() => {
          initSwiper(entry.target);
        });
        observerInstance.unobserve(entry.target);
      }
    });
  }, { rootMargin: '300px' }); // Trigger init 300px before it enters the viewport

  swiperWrappers.forEach(wrapper => observer.observe(wrapper));

  window.addEventListener('orientationchange', () => {
    setTimeout(() => {
      swiperWrappers.forEach(wrapper => {
        if (wrapper.classList.contains('is-initialized')) {
          initSwiper(wrapper);
        }
      });
    }, 150); // Allow DOM to repaint with new orientation bounds
  });

  // Lazy-load zoom logic
  let isZoomScriptLoaded = false;
  
  const loadZoomScript = (wrapper) => {
    if (isZoomScriptLoaded) return;
    const url = wrapper.getAttribute('data-zoom-script-url');
    if (!url) return;
    
    isZoomScriptLoaded = true;
    const script = document.createElement('script');
    script.src = url;
    script.defer = true;
    document.body.appendChild(script);
  };

  swiperWrappers.forEach(wrapper => {
    const triggerEvents = ['mouseenter', 'touchstart'];
    triggerEvents.forEach(evt => {
       wrapper.addEventListener(evt, () => loadZoomScript(wrapper), { once: true, passive: true });
    });
  });
});
